<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    persistent
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        outlined
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
      >
        <v-icon left>mdi-map-search</v-icon>
        Select on Map
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline">
        <v-icon class="mr-2">mdi-map-marker</v-icon>
        Select Address on Map
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <MapAddressSelector
          @address-selected="onAddressSelected"
          @error="onError"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="closeDialog"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Error Snackbar -->
    <v-snackbar
      v-model="showError"
      color="error"
      timeout="5000"
    >
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showError = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import MapAddressSelector from './MapAddressSelector.vue';

export default {
  name: 'MapAddressDialog',
  components: {
    MapAddressSelector
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      showError: false,
      errorMessage: ''
    }
  },
  methods: {
    onAddressSelected(addressData) {
      this.$emit('address-selected', addressData);
      this.closeDialog();
    },

    onError(message) {
      this.errorMessage = message;
      this.showError = true;
    },

    closeDialog() {
      this.dialog = false;
    }
  }
}
</script>